export default function GeoManufacturerSites() {
        return <iframe
            className="w-full"
            height={window.innerHeight - (window.innerHeight * 0.1)}
            src="https://dev2-gis.velait.kz/ru/analytics/manufacturing-upir-map/"
            frameBorder="0"
            allowFullScreen="true"
        />
}